import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $data: ProviderCreateInput!
  ) {
    createOneProvider(data: $data) {
      name
    }
  }
`

export default () => (
  useMutation(MUTATION, `Fornecedor criado`, mutationTypes.CREATE)
)
